import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'

export default class Modalarticleexpert extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:""
}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.getExpert = this.getExpert.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.props.selectat();
}


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
      this.setState({ id_send:this.props.id_send})
      setTimeout(() => {
        //ภายใน
         Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ Expert: res.data})
        }) 

      }, 0);

  }

  getExpert() {
    setTimeout(() => {
      //ภายใน
       Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
      }) 

    }, 0);

}





  handleChange(event) {    this.setState({idExpert: event.target.value});  }
  handleChange2(event) {    this.setState({faculty: event.target.value});  }

  handleSubmit(event) {
    // alert('A name was submitted: ' + this.state.value);

   setTimeout(() => {

      event.preventDefault();
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idExpert", this.state.idExpert);
      datafrm.append("idsend", this.state.id_send);
      

 Axios
 // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
   .post("https://conference.kpru.ac.th/PHPAPI/insertExpert.php",datafrm)
   .then(res => {
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }
  })


//อัพเดทสถานะ
  Axios
  // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
    .post("https://conference.kpru.ac.th/PHPAPI/updatestapat1.php",datafrm)
    .then(res => {
      console.log("response: ", res)
 
      if (res.data.length !== 0) {
       // this.showitem = true;
        console.log(res)
        console.log(res.data.length)
      }else{
      // window.location.href = '/'
      }
   })
   window.location.href = '/adminconference-sd/superadminstatus'

}, 100);

  //this.props.updateat();
  this.toggle()
  this.getExpert()


  }

  

    render() {
        return (
            <MDBContainer>
            <MDBBtn color="secondary" onClick={this.toggle}>เลือกผู้ทรง</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>{this.props.namearticla}</MDBModalHeader>
              <MDBModalBody>
              <div>
              
        <p>เลือกผู้ทรงคุณวุฒิ</p>
        <select className="browser-default custom-select" onChange={this.handleChange}>
                   <option>------กรุณาเลือกผู้ทรง------</option>
                   {this.state.Expert.map((Expert,index )  => 
                   <option value={Expert.id}>{Expert.register_pname}{Expert.register_nameth} {Expert.register_lnameth}</option>
                   )}
        </select>
        
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
        )
    }
}
